import { isOfType } from '~/utils/functions'

import { IOptions } from '~/interfaces/shared'
import { SearchMeta } from '~/models/Search'

import CategoryQuantityText from './CategoryQuantityText'

type CategoryOptionChildren = {
  label: string
  value: string
  count?: number
}

type CategoryOption = Pick<IOptions, 'id' | 'logo'> &
  Pick<SearchMeta, 'description'> &
  CategoryOptionChildren & {
    children?: CategoryOptionChildren[]
  }

export const getListItemTextPrimary = (option: CategoryOption) =>
  isOfType.number(option.count) ? (
    <CategoryQuantityText label={option.label} quantity={option.count} />
  ) : (
    option.label
  )
